import { createFileRoute, redirect } from '@tanstack/react-router';
import { DTC_ASSET_DAY_BASE_PATH } from '../../../../../../../../features/dtcc/dtc-asset-day/dtc-asset-day-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/')({
  beforeLoad: () => {
    throw redirect({ to: DTC_ASSET_DAY_BASE_PATH });
  },
  preload: false,
});
